import PropTypes from "prop-types";
import { Carousel } from "@asosteam/asos-web-component-library-carousel";
import { MediaContextProvider } from "@asosteam/asos-web-component-library-breakpoints";
import UpSellCarouselHeader from "./UpSellCarouselHeader";
import useCarouselSettings from "../../helpers/useCarouselSettings";

import renderProducts from "./renderProducts";
import { withTranslation } from "../translation";
import {
  VIEWPORT_TO_PAGE_SIZE,
  CAROUSEL_MODE_TO_COLUMN_WIDTH,
  CAROUSEL_ID
} from "./constants";

const UpSellCarousel = ({
  formatTranslation,
  formatNumber,
  products,
  title,
  subtitle,
  ...rest
}) => {
  const { carouselMode, pageSize } = useCarouselSettings();

  const columnWidth = CAROUSEL_MODE_TO_COLUMN_WIDTH[carouselMode];

  const itemCount = products?.length;

  if (itemCount < 14) return null;

  return (
    <>
      <UpSellCarouselHeader
        title={formatTranslation(title)}
        subtitle={formatTranslation(subtitle)}
        itemCount={formatTranslation("plp_web_item_count", {
          smart_count: itemCount,
          count: formatNumber(itemCount)
        })}
      />
      <Carousel
        itemsPerRow={pageSize}
        carouselMode={carouselMode}
        columnWidth={columnWidth}
        paginationTabLabel={(lower, upper, total) =>
          formatTranslation("accessibility_plp_carousel_pagination_tab_label", {
            lowercount: formatNumber(lower),
            uppercount: formatNumber(upper),
            totalcount: formatNumber(total),
            smart_count: total
          })
        }
        paginationTabPanelLabel={() => ""}
        paginationLabelNoPrevious={formatTranslation(
          "generic_carousel_pagination_no_previous"
        )}
        paginationLabelNoNext={formatTranslation(
          "generic_carousel_pagination_no_next"
        )}
        ariaDescribedby={CAROUSEL_ID}
      >
        {renderProducts({ products, ...rest })}
      </Carousel>
    </>
  );
};

UpSellCarousel.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  formatNumber: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  carouselCatId: PropTypes.number.isRequired
};

const WrappedLoader = props => (
  <MediaContextProvider querySet={VIEWPORT_TO_PAGE_SIZE}>
    <UpSellCarousel {...props} />
  </MediaContextProvider>
);

export default withTranslation(WrappedLoader);
